import request from '@/utils/request'

// 查询订单动作列表
export function fetchActionList(params) {
  return request({
    url: '/upkeep/order/initiate/review/page',
    method: 'get',
    params,
  })
}

// 新建订单动作
export function createAction(data) {
  return request({
    url: '/upkeep/order-action',
    method: 'post',
    data,
  })
}

// 处理订单动作
export function processAction(id, data) {
  return request({
    url: `/upkeep/order-action/process/${id}`,
    method: 'put',
    data,
  })
}

// 取消订单动作
export function cancelAction(ids) {
  return request({
    url: '/upkeep/order-action/cancel',
    method: 'put',
    data: ids,
  })
}

// 导出订单动作
export function exportAction(params) {
  return request({
    url: '/upkeep/order-action/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

export function getActionDetail(params) {
  return request({
    url: '/upkeep/order/initiate/review/detail',
    method: 'get',
    params,
  })
}
